var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMonitor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 153,
  height: 153,
  viewBox: "0 0 51 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.5 8.5C14.1364 8.5 4.43182 15.5682 0.5 25.5455C4.43182 35.5227 14.1364 42.5909 25.5 42.5909C36.8636 42.5909 46.5682 35.5227 50.5 25.5455C46.5682 15.5682 36.8636 8.5 25.5 8.5ZM25.5 36.9091C19.2273 36.9091 14.1364 31.8182 14.1364 25.5455C14.1364 19.2727 19.2273 14.1818 25.5 14.1818C31.7727 14.1818 36.8636 19.2727 36.8636 25.5455C36.8636 31.8182 31.7727 36.9091 25.5 36.9091ZM25.5 18.7273C21.7273 18.7273 18.6818 21.7727 18.6818 25.5455C18.6818 29.3182 21.7273 32.3636 25.5 32.3636C29.2727 32.3636 32.3182 29.3182 32.3182 25.5455C32.3182 21.7727 29.2727 18.7273 25.5 18.7273Z",
  fill: "#BDBDBD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMonitor);
export default ForwardRef;